module.exports = __webpack_public_path__ + "img/school-portal@2x.97862772.png";